import { useEffect, useState, useCallback } from 'react';
import { ytStatus, ytCall, ytSync, ytSnapshot, getCode, setCode, clearCode } from '../api/lionjob';

// Màn KẾT NỐI MCP YTRENDS — backend Lionjob nối THẲNG tới MCP server (không qua Claude app),
// nhờ vậy có thể tự kéo dữ liệu trend mà không cần người ngồi bấm.
// Cấu hình bằng biến môi trường ở backend/.env: YTRENDS_MCP_URL / YTRENDS_MCP_TOKEN.
const SECTION_LABEL = {
  market: 'Tổng quan thị trường', breakout: 'Listing bứt phá', trending: 'Từ khoá đang lên',
  opportunities: 'Ngách cơ hội', calendar: 'Lịch mùa vụ', gems: 'Ngách ẩn',
};

export default function YtrendsPage() {
  const [unlocked, setUnlocked] = useState(false);
  const [codeInput, setCodeInput] = useState('');
  const [lockErr, setLockErr] = useState('');
  const [unlocking, setUnlocking] = useState(false);

  const [st, setSt] = useState(null);
  const [snap, setSnap] = useState(null);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState('');
  const [tool, setTool] = useState('');
  const [args, setArgs] = useState('{}');
  const [result, setResult] = useState('');

  const load = useCallback(async () => {
    try {
      const s = await ytStatus();
      setSt(s); setUnlocked(true);
      if (s.tools?.length && !tool) setTool(s.tools[0].name);
      ytSnapshot().then(setSnap).catch(() => setSnap(null));
    } catch (e) {
      const m = e.response?.data?.message || e.message || 'Không kết nối được backend';
      if (e.response?.status === 403) { clearCode(); setUnlocked(false); }
      setLockErr(m); setMsg('Lỗi: ' + m);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { if (getCode()) load(); /* eslint-disable-next-line */ }, []);

  async function unlock(e) {
    e?.preventDefault();
    const c = codeInput.trim(); if (!c) { setLockErr('Nhập mã code'); return; }
    setLockErr(''); setCode(c); setUnlocking(true);
    try { await load(); } finally { setUnlocking(false); }
  }

  async function doCheck() {
    setBusy('check'); setMsg('Đang kiểm tra kết nối…');
    try { const s = await ytStatus(); setSt(s); setMsg(s.connected ? `✓ Kết nối OK — ${s.toolCount} công cụ` : '✗ ' + (s.message || 'Không kết nối được')); }
    catch (e) { setMsg('Lỗi: ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(''); }
  }
  async function doSync() {
    setBusy('sync'); setMsg('Đang kéo dữ liệu từ Ytrends… (có thể mất một lúc)');
    try { const r = await ytSync({}); setMsg('✓ ' + r.message); ytSnapshot().then(setSnap).catch(() => {}); }
    catch (e) { setMsg('Lỗi kéo dữ liệu: ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(''); }
  }
  async function doCall() {
    setBusy('call'); setResult(''); setMsg('Đang gọi ' + tool + '…');
    let parsed = {};
    try { parsed = args.trim() ? JSON.parse(args) : {}; }
    catch { setMsg('Tham số không phải JSON hợp lệ'); setBusy(''); return; }
    try { const d = await ytCall(tool, parsed); setResult(JSON.stringify(d, null, 2)); setMsg('✓ Gọi xong'); }
    catch (e) { setResult(''); setMsg('Lỗi: ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(''); }
  }

  if (!unlocked) {
    return (
      <div className="yt-root"><style>{CSS}</style>
        <div className="yt-lock"><div className="yt-lockCard">
          <div className="yt-lockIco">🦁</div><h2>Ytrends</h2>
          <p className="yt-lockSub">Khu vực chỉ dành cho Giám đốc. Nhập mã code để mở.</p>
          <form onSubmit={unlock}>
            <input className="yt-lockInput" type="password" autoFocus placeholder="Mã code" disabled={unlocking}
              value={codeInput} onChange={(e) => setCodeInput(e.target.value)} />
            <button className="yt-btn primary" type="submit" disabled={unlocking} style={{ width: '100%', marginTop: 10 }}>
              {unlocking ? '⏳ Đang kết nối…' : 'Mở khóa'}</button>
          </form>
          {lockErr && <div className="yt-lockErr">⚠ {lockErr}</div>}
        </div></div>
      </div>
    );
  }

  const configured = st?.configured;
  const connected = st?.connected;

  return (
    <div className="yt-root"><style>{CSS}</style>
      <div className="yt-head">
        <div>
          <h2>Ytrends <span className="yt-tag">MCP</span></h2>
          <div className="yt-sub">{msg || 'Backend Lionjob nối thẳng tới MCP server Ytrends để tự kéo dữ liệu trend.'}</div>
        </div>
        <div className="yt-sp" />
        <button className="yt-btn" onClick={doCheck} disabled={!!busy}>{busy === 'check' ? '⏳…' : '↻ Kiểm tra kết nối'}</button>
        <button className="yt-btn primary" onClick={doSync} disabled={!!busy || !connected}
          title={connected ? 'Kéo đủ các khối và lưu snapshot hôm nay' : 'Cần kết nối được trước'}>
          {busy === 'sync' ? '⏳ Đang kéo…' : '⤓ Kéo dữ liệu hôm nay'}</button>
      </div>

      {/* Trạng thái kết nối */}
      <div className={'yt-status ' + (connected ? 'ok' : configured ? 'err' : 'warn')}>
        <div className="yt-dot" />
        <div style={{ minWidth: 0, flex: 1 }}>
          <div className="yt-stitle">
            {connected ? 'Đã kết nối MCP Ytrends' : configured ? 'Không kết nối được' : 'Chưa cấu hình'}
          </div>
          <div className="yt-smeta">
            {connected && <>{st.url} · {st.toolCount} công cụ</>}
            {!connected && configured && <>{st.url} — {st.message}</>}
            {!configured && <>Thêm <code>YTRENDS_MCP_URL</code> (và <code>YTRENDS_MCP_TOKEN</code> nếu cần) vào <code>backend/.env</code> rồi khởi động lại backend.</>}
          </div>
        </div>
        {st?.lastSnapshot && <div className="yt-last">Dữ liệu gần nhất<br /><b>{st.lastSnapshot.day}</b></div>}
      </div>

      {!configured && (
        <div className="yt-guide">
          <h3>Cách nối</h3>
          <ol>
            <li>Mở <code>backend/.env</code>, thêm:
              <pre>{`YTRENDS_MCP_URL=https://<host>/mcp
YTRENDS_MCP_TOKEN=<token nếu server yêu cầu>`}</pre>
            </li>
            <li>Khởi động lại backend.</li>
            <li>Quay lại đây bấm <b>Kiểm tra kết nối</b> — nếu OK sẽ hiện danh sách công cụ.</li>
          </ol>
          <p className="yt-hint">Nếu server dùng header khác Bearer, đặt thêm <code>YTRENDS_MCP_HEADERS={'{"X-Api-Key":"..."}'}</code>.</p>
        </div>
      )}

      {connected && (
        <>
          <div className="yt-card">
            <h3>Công cụ server cung cấp ({st.toolCount})</h3>
            <div className="yt-tools">
              {st.tools.map((t) => (
                <button key={t.name} className={'yt-tool' + (tool === t.name ? ' on' : '')} onClick={() => setTool(t.name)}>
                  <b>{t.name}</b>{t.description ? <span>{t.description}</span> : null}
                </button>
              ))}
            </div>
          </div>

          <div className="yt-card">
            <h3>Gọi thử một công cụ</h3>
            <p className="yt-hint">Dùng để dò tham số trước khi đưa vào tự động. Tham số dạng JSON, để <code>{'{}'}</code> nếu không cần.</p>
            <div className="yt-row">
              <select className="yt-fld" value={tool} onChange={(e) => setTool(e.target.value)}>
                {st.tools.map((t) => <option key={t.name} value={t.name}>{t.name}</option>)}
              </select>
              <input className="yt-fld mono" style={{ flex: 1, minWidth: 180 }} value={args}
                onChange={(e) => setArgs(e.target.value)} placeholder='{"limit": 10}' />
              <button className="yt-btn primary" onClick={doCall} disabled={!!busy}>{busy === 'call' ? '⏳…' : 'Gọi'}</button>
            </div>
            {result && <pre className="yt-out">{result.slice(0, 4000)}</pre>}
          </div>
        </>
      )}

      {snap && (
        <div className="yt-card">
          <h3>Dữ liệu đã lưu — ngày {snap.day}</h3>
          <div className="yt-secs">
            {Object.entries(snap.sections || {}).map(([k, v]) => (
              <div key={k} className={'yt-sec' + (v.ok ? '' : ' bad')}>
                <div className="yt-seck">{SECTION_LABEL[k] || k}</div>
                <div className="yt-secv">{v.ok ? '✓ lấy được' : '✗ ' + (v.error || 'lỗi')}</div>
                <div className="yt-sect">{v.tool || '—'}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const CSS = `
.yt-root{color:var(--text);padding-bottom:40px}
.yt-head{display:flex;gap:12px;align-items:flex-start;margin-bottom:16px;flex-wrap:wrap}
.yt-head h2{margin:0;font-size:20px}
.yt-tag{font-size:11px;color:var(--accent);border:1px solid var(--accent);border-radius:6px;padding:1px 6px;margin-left:6px;vertical-align:middle}
.yt-sub{color:var(--muted);font-size:12.5px;margin-top:3px;max-width:75ch}
.yt-sp{flex:1}
.yt-btn{background:var(--panel);color:var(--text);border:1px solid var(--border);padding:7px 13px;border-radius:9px;cursor:pointer;font-size:13px}
.yt-btn:hover:not(:disabled){border-color:var(--accent)}
.yt-btn:disabled{opacity:.45;cursor:not-allowed}
.yt-btn.primary{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}

.yt-status{display:flex;gap:12px;align-items:center;border:1px solid var(--border);border-radius:var(--radius);padding:13px 15px;background:var(--panel);margin-bottom:14px}
.yt-status .yt-dot{width:10px;height:10px;border-radius:50%;flex:none}
.yt-status.ok{border-color:var(--ok)} .yt-status.ok .yt-dot{background:var(--ok)}
.yt-status.err{border-color:var(--danger)} .yt-status.err .yt-dot{background:var(--danger)}
.yt-status.warn{border-color:var(--warn)} .yt-status.warn .yt-dot{background:var(--warn)}
.yt-stitle{font-weight:600;font-size:14px}
.yt-smeta{color:var(--muted);font-size:12px;margin-top:2px;word-break:break-all}
.yt-last{text-align:right;font-size:11px;color:var(--muted);flex:none}
.yt-last b{color:var(--text);font-family:var(--font-mono);font-size:13px}

.yt-card,.yt-guide{border:1px solid var(--border);border-radius:var(--radius);padding:14px 16px;background:var(--panel);margin-bottom:14px}
.yt-card h3,.yt-guide h3{margin:0 0 8px;font-size:13px;letter-spacing:.06em;text-transform:uppercase;color:var(--muted)}
.yt-hint{color:var(--muted);font-size:12px;margin:0 0 10px}
.yt-guide ol{margin:0;padding-left:20px;font-size:13px;line-height:1.8}
.yt-guide pre,.yt-out{background:var(--input);border:1px solid var(--border);border-radius:8px;padding:10px 12px;font-family:var(--font-mono);font-size:11.5px;overflow-x:auto;margin:6px 0 0}
.yt-out{max-height:340px;overflow:auto;margin-top:10px;white-space:pre-wrap;word-break:break-word}
code{background:var(--input);border-radius:4px;padding:1px 5px;font-family:var(--font-mono);font-size:11.5px}

.yt-tools{display:grid;grid-template-columns:repeat(auto-fill,minmax(230px,1fr));gap:8px}
.yt-tool{text-align:left;border:1px solid var(--border);background:var(--input);border-radius:9px;padding:8px 10px;cursor:pointer;font:inherit;color:var(--text);display:flex;flex-direction:column;gap:2px}
.yt-tool:hover{border-color:var(--accent)}
.yt-tool.on{border-color:var(--accent);box-shadow:0 0 0 1px var(--accent)}
.yt-tool b{font-size:12px;font-family:var(--font-mono)}
.yt-tool span{font-size:11px;color:var(--muted)}

.yt-row{display:flex;gap:8px;align-items:center;flex-wrap:wrap}
.yt-fld{border:1px solid var(--border);background:var(--input);color:var(--text);font:inherit;font-size:12px;padding:7px 10px;border-radius:8px}
.yt-fld.mono{font-family:var(--font-mono)}

.yt-secs{display:grid;grid-template-columns:repeat(auto-fill,minmax(180px,1fr));gap:8px}
.yt-sec{border:1px solid var(--ok);border-radius:9px;padding:9px 11px}
.yt-sec.bad{border-color:var(--danger)}
.yt-seck{font-size:12px;font-weight:600}
.yt-secv{font-size:11.5px;color:var(--ok);margin-top:2px}
.yt-sec.bad .yt-secv{color:var(--danger)}
.yt-sect{font-size:10.5px;color:var(--muted);font-family:var(--font-mono);margin-top:2px}

.yt-lock{display:flex;justify-content:center;padding:60px 20px}
.yt-lockCard{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:28px 26px;width:340px;text-align:center}
.yt-lockIco{font-size:38px;line-height:1}.yt-lockCard h2{margin:8px 0 4px}
.yt-lockSub{color:var(--muted);font-size:13px;margin:0 0 16px}
.yt-lockInput{width:100%;background:var(--input);color:var(--text);border:1px solid var(--border);border-radius:10px;padding:10px 12px;font-size:14px;text-align:center;letter-spacing:2px}
.yt-lockErr{color:var(--danger);font-size:12px;margin-top:10px}
`;
